export default __webpack_public_path__ + "static/media/dr-sophie-tools.4c98da83.jpg";